<template>
  <div class="industry-model">
    <!-- Tab 导航 -->
    <div class="tab-nav">
      <button
          v-for="(item, index) in industryData"
          :key="item.id"
          class="tab-btn"
          :class="{ active: currentTabIndex === index }"
          @click="switchTab(index)"
      >
        <img class="tab-icon" :src="item.icon">
        {{ $t(item.nameKey) }}
      </button>
    </div>

    <!-- 图片网格 - 使用 mode="out-in" 避免同时存在新旧元素 -->
    <transition name="grid-switch" mode="out-in">
      <div class="image-grid" :key="currentTabIndex">
        <div
            v-for="(item, index) in currentList"
            :key="item.title"
            class="image-card"
        >
          <div class="img-wrapper">
            <div v-if="!loadedImages[`${currentTabIndex}-${index}`]" class="img-loading">
              <div class="spinner"></div>
              <div class="loading-text">加载中...</div>
            </div>
            <img
                :src="item.image"
                :alt="item.title"
                loading="lazy"
                @load="onImageLoad(index)"
                @error="onImageError(index)"
                :class="{ loaded: loadedImages[`${currentTabIndex}-${index}`] }"
            />
          </div>
          <div class="card-title">{{ $t(item.titleKey) }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import IndustryModel from "@/config/IndustryModel.js"

export default {
  name: 'IndustryModel',
  data() {
    return {
      industryData: IndustryModel,
      currentTabIndex: 0,
      loadedImages: {},
    }
  },
  computed: {
    currentList() {
      return this.industryData[this.currentTabIndex]?.list || []
    }
  },
  methods: {
    switchTab(index) {
      if (index === this.currentTabIndex) return
      this.currentTabIndex = index
      // 切换 tab 时重置当前 tab 的加载状态
      this.currentList.forEach((_, i) => {
        this.$delete(this.loadedImages, `${index}-${i}`)
      })
    },
    onImageLoad(index) {
      this.$set(this.loadedImages, `${this.currentTabIndex}-${index}`, true)
    },
    onImageError(index) {
      this.$set(this.loadedImages, `${this.currentTabIndex}-${index}`, 'error')
    }
  }
}
</script>

<style scoped>
.industry-model {
  padding: 4vh 16vh;
  margin: 0 auto;
}

/* Tab 导航栏 */
.tab-nav {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  justify-content: center;
  .tab-icon{
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
}

.tab-btn {
  padding: 10px 32px;
  border: none;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  background: none;
  color: #BFBFBF;
  outline: none;
  display: flex;
  align-items: center;
  .tab-btn:hover {
    background: #b0b0b0;
  }
  &.active {
    //background: #2563eb;
    //box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
    color: #E7E7E7;
    background-image: linear-gradient(90deg, rgb(73, 64, 238) 0%, rgb(108, 234, 148) 100%);
    background-color: initial;
    background-size: auto;
  }
}

/* 图片网格 */
.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30vh, 1fr));
  gap: 20px;
}

/* 网格切换动画 - mode="out-in" 确保旧内容完全消失后新内容才出现 */
.grid-switch-enter-active {
  transition: all 0.35s ease;
}

.grid-switch-leave-active {
  transition: all 0.2s ease;
}

.grid-switch-enter {
  opacity: 0;
  transform: translateY(12px);
}

.grid-switch-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.image-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.image-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.img-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  overflow: hidden;
  background: #f5f7fa;
}

.img-wrapper img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.4s ease, transform 0.4s ease;
  opacity: 0;
}

.img-wrapper img.loaded {
  opacity: 1;
}

.image-card:hover .img-wrapper img.loaded {
  transform: scale(1.05);
}

/* Loading 动画 */
.img-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  pointer-events: none;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e0e6ed;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.loading-text {
  font-size: 12px;
  color: #909399;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.card-title {
  padding: 14px 16px;
  font-size: 14px;
  color: #333;
  text-align: center;
  font-weight: 500;
  background: #fff;
}
</style>